export const d = () => {};

export const getParameter = (arr, key) => (
  arr.map(e => e[key])
    .filter((item, index, self) => self.indexOf(item) === index)
);

export const scroll = (el) => {
  const target = document.querySelector(el);
  const { offsetTop } = target;
  // const c = document.documentElement.scrollTop || document.body.scrollTop;
  window.scrollTo(0, offsetTop);
  // const smoothScroll = element =>
  //   document.querySelector(element).scrollIntoView({
  //     behavior: 'smooth',
  //   });
  // smoothScroll(el);
};



// WEBPACK FOOTER //
// ./src/helpers/util.js